import {
  Dispatch,
  MutableRefObject,
  SetStateAction,
  useRef,
  useState,
} from 'react';

export function useStateRef<T>(
  initialState?: T,
): [
  typeof initialState extends undefined ? T | undefined : T,
  Dispatch<
    SetStateAction<typeof initialState extends undefined ? T | undefined : T>
  >,
  MutableRefObject<typeof initialState extends undefined ? T | undefined : T>,
] {
  const [state, setState] = useState<
    typeof initialState extends undefined ? T | undefined : T
  >(initialState as typeof initialState extends undefined ? T | undefined : T);

  const stateRef = useRef(state);
  stateRef.current = state;

  return [state, setState, stateRef];
}
